import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

export default function DatePickerControl(props) {

    const [value, setValue] = useState(null);

    function onChange(value) {
        setValue(value);
        if (props.onChange)
            props.onChange(value)
    }

    function onBlur(value) {
        setValue(value);
        if (props.onBlur)
            props.onBlur(value)
    }
	
	function CalendarClick(e){
		e.target.parentNode.querySelector('input').focus()
	}

    return (
        <div style={{position:'relative'}}>
			{props.title != null ? 
				<i onClick={CalendarClick} class="fa fa-calendar" style={{position:'absolute',top:'34px',left:'8px', fontSize:'22px'}} aria-hidden="true"></i>
            :
				<i onClick={CalendarClick} class="fa fa-calendar" style={{position:'absolute',top:'6px',left:'8px', fontSize:'22px'}} aria-hidden="true"></i>			
			}
			<Form.Group className="mb-3 datePicker">
				{props.title != null && 
					<Form.Label>{props.title}<span class="text-danger fw-bold"> {props.required && '*'}</span> </Form.Label>
				}
				<DatePicker
					ref={props.inputRef}
					className={props.className}
					placeholder={props.placeholder}
					value={props.value}
					locale={persian_fa}
					calendar={persian}
					onChange={onChange}
					onBlur={(e) => onBlur(e.target.value)}
					disabled={props.disabled ? true : false}
				/>
            </Form.Group>			
        </div>
    )
}